import React from 'react';

const AppStoreIcon: React.FC<React.SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={137}
      height={41}
      viewBox="0 0 137 41"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-786 -699) translate(274 670.5) translate(512.5 29)">
              <rect width={136} height={40} fill="#F2F2F2" rx={4} />
              <text
                fill="#3A3A3A"
                fontFamily="Public Sans, sans-serif"
                fontSize={10}
              >
                <tspan x="47.438" y="15.25">
                  Descargalo en el
                </tspan>
              </text>
              <text
                fill="#3A3A3A"
                fontFamily="Public Sans, sans-serif"
                fontSize={16}
              >
                <tspan x="48.735" y="29.375">
                  App Store
                </tspan>
              </text>
              <g fill="#565656" fillRule="nonzero">
                <path
                  d="M19.967 21.02c-.984 1.463-2.001 2.917-3.608 2.948-1.581.03-2.088-.953-3.892-.953-1.806 0-2.371.922-3.864.983-1.551.06-2.73-1.58-3.722-3.036-2.027-2.978-3.573-8.42-1.493-12.093C4.418 7.045 6.263 5.89 8.263 5.86c1.523-.028 2.962 1.045 3.893 1.045.931 0 2.678-1.288 4.514-1.1.769.033 2.926.316 4.31 2.377-.109.073-2.574 1.532-2.544 4.57.03 3.631 3.128 4.838 3.164 4.854-.028.085-.495 1.723-1.633 3.414zM13.221 1.818C14.071.804 15.51.05 16.694 0c.152 1.408-.405 2.817-1.227 3.833-.825 1.014-2.174 1.804-3.497 1.698-.18-1.377.487-2.813 1.251-3.713z"
                  transform="translate(7.389 6.625)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export default React.memo(AppStoreIcon);
